import { gsap, ScrollTrigger } from '../gsap/setup';
import SmoothScroll from '../singleton/SmoothScroll';

gsap.registerPlugin(ScrollTrigger);

function prefersReducedMotion() {
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

class HeroScrollGrid {
  constructor(el) {
    this.el = el;
    this.ctx = null;
    this.onImageLoad = this.onImageLoad.bind(this);
    this.init();
    this.bindImageLoadRefresh();
  }

  init() {
    const items = [...this.el.querySelectorAll('.hero-scroll-grid__item')];

    if (!items.length) return;

    this.ctx = gsap.context(() => {
      items.forEach((item) => {
        const yPercentRandomVal = gsap.utils.random(-100, 100);

        gsap.to(item, {
          ease: 'none',
          yPercent: yPercentRandomVal,
          scrollTrigger: {
            trigger: item,
            start: 'top bottom',
            end: 'top top',
            scrub: true,
          },
        });
      });
    }, this.el);
  }

  bindImageLoadRefresh() {
    this.el.querySelectorAll('img').forEach((img) => {
      if (img.complete) return;
      img.addEventListener('load', this.onImageLoad, { once: true });
    });
  }

  onImageLoad() {
    SmoothScroll.scheduleRefresh();
  }

  destroy() {
    this.el.querySelectorAll('img').forEach((img) => {
      img.removeEventListener('load', this.onImageLoad);
    });
    this.ctx?.revert();
    this.ctx = null;
  }
}

let instances = [];

export function initHeroScrollGrid() {
  destroyHeroScrollGrid();

  if (prefersReducedMotion()) return;

  document.querySelectorAll('.js-hero-scroll-grid').forEach((el) => {
    instances.push(new HeroScrollGrid(el));
  });

  if (!instances.length) return;

  requestAnimationFrame(() => {
    SmoothScroll.refresh();
  });
}

export function destroyHeroScrollGrid() {
  instances.forEach((instance) => instance.destroy());
  instances = [];
}
